export const INSTRUCTOR_ID_LOCAL_STORAGE_KEY = "auth:id";
export const INSTRUCTOR_FIRST_NAME_LOCAL_STORAGE_KEY = "auth:fn";
export const INSTRUCTOR_LAST_NAME_LOCAL_STORAGE_KEY = "auth:ln";
export const INSTRUCTOR_BRAND_LOCAL_STORAGE_KEY = "auth:brand";
export const INSTRUCTOR_ADI_NUMBER_LOCAL_STORAGE_KEY = "auth:adi";
export const INSTRUCTOR_STATUS_LOCAL_STORAGE_KEY = "auth:status";

export const IS_COGNITO_AUTH_ENABLED =
  process.env.REACT_APP_HUBCAPP_ENABLE_SIMPLE_AUTH === "true"
    ? false
    : process.env.REACT_APP_ENABLE_AUTH === "true";

export const STORYBOOK_DISABLE_AUTH_CHECK =
  process.env.STORYBOOK_DISABLE_AUTH_CHECK === "true";
